import _ from 'lodash';
import React from 'react';
import { cx, PropTypes } from '~/utils';

export function IconCounter( props_in ) {
  const { text, count, position, className, ...props } = props_in;
  const classes = cx(
    'fa-layers-counter',
    className,
    `fa-layers-${position}`,
  );
  return <span className={classes} {...props}>{text || count}</span>;
}
IconCounter.propTypes = {
  text        : PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] ),
  count       : PropTypes.oneOfType( [ PropTypes.string, PropTypes.number ] ),
  className   : PropTypes.className,
  transform   : PropTypes.oneOfType( [ PropTypes.string, PropTypes.object ] ),
  position    : PropTypes.oneOf( [
    'bottom-left', 'bottom-right', 'top-left', 'top-right',
  ] ),
};
IconCounter.defaultProps = {
  position    : 'top-right',
};
